import en_US from "./master-app";

// Function to dynamically import locale files
async function loadLocale(locale: string): Promise<AppLocale> {
  switch (locale) {
    case "en_US":
      return en_US;
    case "da_DK":
      return {
        ...((await import("./generated/da-DK")).default as unknown as AppLocale),
        ...((await import("./overrides/da-DK")).default as unknown as AppLocale),
      };
    case "pt_BR":
      return {
        ...((await import("./generated/pt-BR")).default as unknown as AppLocale),
        ...((await import("./overrides/pt-BR1")).default as unknown as AppLocale),
        ...((await import("./overrides/pt-BR2")).default as unknown as AppLocale),
        ...((await import("./overrides/pt-BR3")).default as unknown as AppLocale),
      };
    case "pl_PL":
      return {
        ...((await import("./generated/pl-PL")).default as unknown as AppLocale),
        ...((await import("./overrides/pl-PL1")).default as unknown as AppLocale),
        ...((await import("./overrides/pl-PL2")).default as unknown as AppLocale),
      };
    case "zh_CN":
      return {
        ...((await import("./generated/zh-CN")).default as unknown as AppLocale),
        ...((await import("./overrides/zh-CN")).default as unknown as AppLocale),
      };
    case "fr_FR":
      return {
        ...((await import("./generated/fr-FR")).default as unknown as AppLocale),
        ...((await import("./overrides/fr-FR")).default as unknown as AppLocale),
      };
    case "it_IT":
      return {
        ...((await import("./generated/it-IT")).default as unknown as AppLocale),
        ...((await import("./overrides/it-IT")).default as unknown as AppLocale),
      };
    case "es_MX":
      return {
        ...((await import("./generated/es-MX")).default as unknown as AppLocale),
        ...((await import("./overrides/es-MX")).default as unknown as AppLocale),
      };
    case "jp_JP":
      return {
        ...((await import("./generated/jp-JP")).default as unknown as AppLocale),
        ...((await import("./overrides/jp-JP")).default as unknown as AppLocale),
      };
    case "ko_KR":
      return {
        ...((await import("./generated/ko-KR")).default as unknown as AppLocale),
        ...((await import("./overrides/ko-KR")).default as unknown as AppLocale),
      };
    case "nl_NL":
      return {
        ...((await import("./generated/nl-NL")).default as unknown as AppLocale),
        ...((await import("./overrides/nl-NL")).default as unknown as AppLocale),
      };
    case "he_IL":
      return {
        ...((await import("./generated/he-IL")).default as unknown as AppLocale),
        ...((await import("./overrides/he-IL")).default as unknown as AppLocale),
      };
    case "de_DE":
      return {
        ...((await import("./generated/de-DE")).default as unknown as AppLocale),
        ...((await import("./overrides/de-DE")).default as unknown as AppLocale),
      };
    case "lt_LT":
      return {
        ...((await import("./generated/lt-LT")).default as unknown as AppLocale),
        ...((await import("./overrides/lt-LT")).default as unknown as AppLocale),
      };
    case "vi_VN":
      return {
        ...((await import("./generated/vi-VN")).default as unknown as AppLocale),
        ...((await import("./overrides/vi-VN")).default as unknown as AppLocale),
      };
    default:
      throw new Error(`Unknown locale: ${locale}`);
  }
}

export type AppLocale = typeof en_US;

export const locales: Record<string, () => Promise<AppLocale>> = {
  en_US: () => loadLocale("en_US"),
  pt_BR: () => loadLocale("pt_BR"),
  es_MX: () => loadLocale("es_MX"),
  de_DE: () => loadLocale("de_DE"),
  fr_FR: () => loadLocale("fr_FR"),
  it_IT: () => loadLocale("it_IT"),
  zh_CN: () => loadLocale("zh_CN"),
  jp_JP: () => loadLocale("jp_JP"),
  ko_KR: () => loadLocale("ko_KR"),
  nl_NL: () => loadLocale("nl_NL"),
  he_IL: () => loadLocale("he_IL"),
  pl_PL: () => loadLocale("pl_PL"),
  da_DK: () => loadLocale("da_DK"),
  lt_LT: () => loadLocale("lt_LT"),
  vi_VN: () => loadLocale("vi_VN"),
};

export type Locale =
  | "en-US"
  | "zh-CN"
  | "pt-BR"
  | "pl-PL"
  | "da-DK"
  | "fr-FR"
  | "it-IT"
  | "es-MX"
  | "jp-JP"
  | "ko-KR"
  | "nl-NL"
  | "he-IL"
  | "de-DE"
  | "lt-LT"
  | "vi-VN";

// Function to get UI language selector labels
export async function getUiLanguageSelectorLabels() {
  const labels = await Promise.all(
    Object.entries(locales).map(async ([key, loadLocale]) => {
      const locale = await loadLocale();
      return [key, locale.language];
    }),
  );
  return labels;
}

export const uiLanguageKeys = Object.keys(locales);

export const defaultLocale = en_US;
